import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'date',
    headerName: 'תאריך',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'area',
    headerName: 'איזור',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'percent',
    headerName: '% כיסוי',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
]

export default columnsConfig
